import { toast } from "react-toastify";

import {
  OrganizationDto,
  PriceScraperRequestBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { organizationsKeys } from "../queryKeys";

const mutatePriceScrapperConfig = async (
  values: string[]
): Promise<OrganizationDto> => {
  const resp = await api.post<OrganizationDto, PriceScraperRequestBodyType>(
    "/v2/organizations/price-scraper",
    { urls: values }
  );
  return resp.data;
};

export const useMutatePriceScraperConfig = () => {
  const queryClient = useQueryClient();
  return useMutation<OrganizationDto, Error, any, any>({
    mutationKey: ["updateConfiguration"],
    mutationFn: async (data: string[]) => mutatePriceScrapperConfig(data),
    onSuccess: (data) => {
      queryClient.setQueryData(organizationsKeys.one, { org: data });
      toast.success("Price AI Submission Successful!");
    },
  });
};
